<template>
  <router-link :to="convertRoute(to)" :target="target" class="app-link"><slot></slot></router-link>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppLink extends AppComponent {
  @Prop({required: true})
  to;
  @Prop({required: false})
  target;
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppLink.vue